<template>
  <div class="dome">
    <mode1 @onAddress="onAddress"></mode1>
    <el-table
        ref="multipleTable"
        :data="addressData"
        max-height="500px"
        border
        style="width: 100%">
      <el-table-column label="序号" width="70">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单编号" width="180"/>
      <el-table-column prop="name" label="姓名" width="120"/>
      <el-table-column prop="mobile" label="电话" width="120"/>
      <el-table-column prop="address" label="地址"/>

    </el-table>
  </div>
</template>

<script>
import mode1 from "./components/mode_1"

export default {
  name: "index",
  components: {
    mode1
  },
  data() {
    return {
      addressData: []
    }
  },
  methods: {
    onAddress(row) {
      this.addressData = row.data;
      console.log('addressData====',this.addressData);
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/dome/index.vue